import { useState } from 'react';
import { Button } from '@asigna/kit';
import { NonceInput, SetTxFee, TransactionCommonDialog } from 'components';

interface Props {
  onClose: () => void;
  onSuccess: (val: number, fee: number) => void;
  transactionHex: string;
  isFee: boolean;
}

export const NonceDialog = (props: Props) => {
  const { onSuccess, isFee, transactionHex } = props;
  const [nonce, setNonce] = useState(-1);
  const [step, setStep] = useState(1);

  const nextButton = () => {
    return (
      <Button
        disabled={false}
        onClick={() => {
          if (step === 1 && !isFee) {
            setStep(2);
          } else if (step === 1) {
            onSuccess(nonce, 0);
          }
        }}
        message={step === 1 ? 'Next' : 'Sign'}
        fullWidth
        colorType="primary"
      />
    );
  };

  return (
    <TransactionCommonDialog
      title="Configure Transaction"
      open
      onClose={props.onClose}
      button={step === 1 ? nextButton() : undefined}
    >
      {step === 1 && (
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <NonceInput value={nonce} onChange={setNonce} />
        </div>
      )}
      {step === 2 && (
        <SetTxFee
          transactionHex={transactionHex}
          onSend={async (fee) => {
            onSuccess(nonce, fee);
          }}
          onBackClick={() => {
            setStep(1);
          }}
        />
      )}
    </TransactionCommonDialog>
  );
};
